import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuth from '../../common/WithAuth';
import DialogProcessOrderProduct from '../../pages/CartViewer/DialogProcessOrderProduct';
import {
    getListProductRequested,
    clearListProduct,
    getUserProfileRequested,
    clearGetUserProfile,
    orderProductRequested,
    clearOrderProduct,
    getCountProductRequested,
    getListHistoryOrderRequested,
} from '../../actions/CartViewer';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    isLoading: state.cartViewer.getListProduct.isFetching
        || state.cartViewer.orderProduct.isFetching,
    listProductOrder: state.cartViewer.getListProduct.data,
    userProfile: state.cartViewer.userProfile.data,
    eventInfo: state.registration.registrationViewer.data,
    successOrder: state.cartViewer.orderProduct.success,
    errorOrder: state.cartViewer.orderProduct.errors,
});

const mapDispatchToProps = (dispatch) => ({
    getListProductCart: (param) => {
        dispatch(getListProductRequested(param));
    },
    clearProduct: () => {
        dispatch(clearListProduct());
    },
    getUserProfile: (param) => {
        dispatch(getUserProfileRequested(param));
    },
    clearUserProfile: () => {
        dispatch(clearGetUserProfile());
    },
    orderProduct: (param) => {
        dispatch(orderProductRequested(param));
    },
    clearOrderProduct: () => {
        dispatch(clearOrderProduct());
    },
    getCount: () => {
        dispatch(getCountProductRequested());
    },
    getListHistoryOrder: (param) => {
        dispatch(getListHistoryOrderRequested(param));
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DialogProcessOrderProduct);
